import React from 'react';
import NextImage, { StaticImageData } from 'next/image';

import { ArrowLinkProps } from 'Elements/Link/Arrow';

import {
    Container,
    Inner,
    DesktopHeading,
    HeadingLink,
    SmallerScreenHeading,
    Description,
    StyledArrowLink,
    ImageWrapper
} from './Facility.styled';

export interface Props {
    heading: string;
    description: string;
    link: ArrowLinkProps;
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
}

const Facility: React.FC<Props> = props => {
    const { heading, description, link, image } = props;

    return (
        <Container>
            <ImageWrapper>
                <NextImage
                    src={image.src}
                    alt={image.alt || ''}
                    fill
                    style={{ objectFit: 'cover' }}
                />
            </ImageWrapper>
            <Inner>
                <div>
                    <DesktopHeading>{heading}</DesktopHeading>
                    <SmallerScreenHeading>
                        <HeadingLink id={link.id} aria-label={link.ariaLabel} href={link.href}>
                            {heading}
                        </HeadingLink>
                    </SmallerScreenHeading>
                    <Description>{description}</Description>
                </div>
                <StyledArrowLink {...link} />
            </Inner>
        </Container>
    );
};

export default Facility;
